module.exports = __webpack_public_path__ + "static/media/435_Bedroom4.dc849194.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Bedroom4.jpg
// module id = 556
// module chunks = 0